<ng-container
    #tournaments="tournaments"
    [gameIds]="gameId()"
    lsTournaments
>
    <aside class="tournaments-sidebar__bar">
        <header class="tournaments-sidebar__header">
            @if (isTournamentDetailsSelected && tournamentDetailsSelected) {
                <ng-container
                    #tournament="tournament"
                    [id]="tournamentDetailsSelected.id"
                    lsTournament
                >
                    @if (tournament.tournament(); as item) {
                        <button
                            class="tournaments-sidebar__back"
                            [hasIcon]="true"
                            [name]="'common.button-back' | translate"
                            lsUiButtonKind="subtle"
                            lsUiButtonPalette="neutral-1"
                            lsUiButtonSize="small"
                            (click)="closeTournamentDetails($event)"
                        >
                            <ls-ui-icon
                                height="24"
                                src="chevron"
                                width="24"
                            />
                        </button>

                        <h2 class="tournaments-sidebar__title _system-sub-xl _800">{{ item.name }}</h2>
                    }
                </ng-container>
            } @else {
                <h2 class="tournaments-sidebar__title _system-sub-xl _800">{{ 'tournaments.title' | translate }}</h2>
            }

            <button
                class="tournaments-sidebar__close"
                [hasIcon]="true"
                [name]="'common.button-close' | translate"
                lsUiButtonKind="basic"
                lsUiButtonPalette="neutral-1"
                lsUiButtonSize="small"
                (click)="closeSidebar($event)"
            >
                <ls-ui-icon
                    height="24"
                    src="cross"
                    width="24"
                />
            </button>
        </header>

        <div
            #sidebarBody
            class="tournaments-sidebar__body"
        >
            @if (tournaments.list()?.length) {
                @if (isTournamentDetailsSelected && tournamentDetailsSelected) {
                    <ng-container
                        #tournament="tournament"
                        [id]="tournamentDetailsSelected.id"
                        lsTournament
                    >
                        @if (tournament.tournament(); as item) {
                            <ls-tournament-card
                                class="tournaments-sidebar__card"
                                [id]="item.id"
                                [image]="item.image"
                                [name]="item.name"
                                [minBet]="item.rules.minBet"
                                [startDate]="item.start"
                                [endDate]="item.end"
                                [prize]="(item.rules | getPoolPrize)"
                                [status]="item.status"
                                [autoJoin]="item.autoJoin"
                                [isJoined]="item.joined"
                                [isJoinable]="item.joinable"
                                [isDetailsView]="true"
                                [isInSidebar]="true"
                                [mode]="item.mode"
                                [participationFee]="item.rules.participationFee"
                            />

                            @if (item.mode === tournamentMode.Platform) {
                                <ls-leaderboard [list]="item.leaderboard"/>
                            }

                            @if (item.description) {
                                <ls-tournament-description
                                    [description]="item.description"
                                    [terms]="item.terms"
                                />
                            }

                            @if (item.rules.games.length) {
                                <ls-tournaments-games-list
                                    [list]="item.rules.games"
                                    (lsOnGameClick)="onGameClick()"
                                />
                            }
                        }
                    </ng-container>
                } @else {
                    @if (tournaments.gameIds()) {
                        @if ((tournaments.filterGameTournaments() | filterGameTournaments : [statusActive])?.length) {
                            <h3 class="tournaments-sidebar__subtitle _has-game _system-sub-sm _800">
                                {{ "tournaments.tournaments-with-the-current-game" | translate }}
                            </h3>

                            @for (item of tournaments.filterGameTournaments() | filterGameTournaments : [statusActive]; track item.id) {
                                <ls-tournament-card
                                    class="tournaments-sidebar__card"
                                    [id]="item.id"
                                    [image]="item.image"
                                    [name]="item.name"
                                    [startDate]="item.start"
                                    [endDate]="item.end"
                                    [prize]="(item.rules | getPoolPrize)"
                                    [status]="item.status"
                                    [autoJoin]="item.autoJoin"
                                    [isJoined]="item.joined"
                                    [isJoinable]="item.joinable"
                                    [isInSidebar]="true"
                                    [isCurrentGame]="true"
                                    [mode]="item.mode"
                                    [participationFee]="item.rules.participationFee"
                                    (lsGoToDetails)="openTournamentDetails(item)"
                                    (lsOnGameClick)="closeSidebar()"
                                />
                            }
                        }

                        @if ((tournaments.filterNoGameTournaments() | filterGameTournaments : [statusActive])?.length) {
                            <h3 class="tournaments-sidebar__subtitle _system-sub-sm _800">
                                {{ "tournaments.other-tournaments" | translate }}
                            </h3>

                            @for (item of tournaments.filterNoGameTournaments() | filterGameTournaments : [statusActive]; track item.id) {
                                <ls-tournament-card
                                    class="tournaments-sidebar__card"
                                    [id]="item.id"
                                    [image]="item.image"
                                    [name]="item.name"
                                    [startDate]="item.start"
                                    [endDate]="item.end"
                                    [prize]="(item.rules | getPoolPrize)"
                                    [status]="item.status"
                                    [gamesList]="item.rules.games"
                                    [autoJoin]="item.autoJoin"
                                    [isJoined]="item.joined"
                                    [isJoinable]="item.joinable"
                                    [isInSidebar]="true"
                                    [mode]="item.mode"
                                    [participationFee]="item.rules.participationFee"
                                    (lsGoToDetails)="openTournamentDetails(item)"
                                    (lsOnGameClick)="closeSidebar()"
                                />
                            }
                        }
                    }
                }
            }
        </div>
    </aside>
</ng-container>
